import { Box, Typography } from '@mui/material'
import FormRow from 'components/form/FormRow'
import DateInput from 'components/form/input/DateInput'
import TextInput from 'components/form/input/TextInput'
import React from 'react'

const RenderQuestao = ({ q, index }) => {
    const { key, type, questao, required } = q
    //["text", "textMult", "number", "date", "instrucao"]
    if (type === "instrucao") {
        return <Typography sx={{ p: 2 }} style={{ whiteSpace: 'pre-line' }}>
            {questao}
        </Typography>
    }
    let propsToText = {}
    if (required === "SIM") {
        propsToText = { ...propsToText, required: true }
    }
    if (type === "textMult") {
        propsToText = { ...propsToText, multiline: true }
    }
    if (type === "number") {
        propsToText = { ...propsToText, type: 'number' }
    }
    if (type === "date") {
        return <FormRow>
            <DateInput
                name={"respostaQuestionario." + (key || questao)} label={questao}
                {...propsToText}
            /></FormRow>
    }
    return <FormRow>
        <TextInput name={"respostaQuestionario." + (key || questao)} label={questao}   {...propsToText} />
    </FormRow >
}
export default function RenderQuestoesSecundarias({ rodada, t }) {

    if (!rodada?.questoesSecundarias) {
        return ""
    }

    return (
        <Box sx={{ width: "100%" }}>
            {rodada.questoesSecundarias.map((q, i) => <RenderQuestao key={i} q={q} />)}
        </Box>
    )
}
